import { Link } from 'react-router-dom';
import ScrollToTop from '../utils/scrollTop';
import { useLocation } from 'react-router-dom';
function Footer() {
    const match = useLocation();
    return (
        <>
        {!(match.pathname=== '/investor/chat' || match.pathname=== '/creator/chat' || match.pathname=== '/artists/chat') &&
        <>
        <ScrollToTop/>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <div className="footer1">
        <Link to="/terms" className='terms'>Terms of service</Link>&nbsp; &nbsp;| &nbsp; &nbsp;
        <Link to="/privacy" className='privacy'>Privacy Policy</Link>&nbsp; &nbsp;| &nbsp; &nbsp;
        <Link to="/cookies" className='cookies'>Cookie Policy</Link>&nbsp; &nbsp;| &nbsp; &nbsp;
        <Link to="/contactus" className='contactus'>Contact Us</Link>
        <p className="footer2">All rights reserved © 2022 Taost.</p>
        <br></br>
        
        </div></>
        }
        </>
    )}

export default Footer